// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__4TTdx","heading":"PrivacyPolicy_heading__zFDqV","markdown":"PrivacyPolicy_markdown__2KIH0"};